module.exports = __webpack_public_path__ + "media/images/lp_consultation/professional02-65fd7f7207a028705b310fd0cca6c6c5.jpg";